module.exports = __webpack_public_path__ + "media/images/wanderweb/wanderweb-circle-530776c8a6eb5f6b1e9222838925b823.png";